import {
  Autocomplete,
  Box,
  Chip,
  Divider,
  FormControl,
  FormLabel,
  TextField,
  Typography,
  IconButton,
  Link,
  ToggleButtonGroup,
  ToggleButton,
  LinearProgress,
  Tooltip
} from "@mui/material";
import CustomHeader from "../pageHeader/Index";
import __ from "underscore";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { useTheme, darken } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect, useReducer, useCallback, useRef } from "react";
import { getTenantDropDownList, storeUserLocationDetailsMutationThunk } from "../../store/thunk/tenantThunk";
import { setTenantId } from "../../store/thunk/commonThunk";
import CustomStepper from "./Stepper";
import { getLocationLists } from "../../store/thunk/locationThunk";
import DashboardFacility from "./FacilityLayout";
import MapViewDashboardFacility from "./MapViewFacility"
import _ from "lodash";
import { getAllDevices, getConfiguredDevicesNew } from "../../store/thunk/deviceThunk";
import { RootState } from "../../store/store";
import { getDeviceWithWorstSubstanceData } from "../../store/thunk/dashboardThunk";
import { CircleSVG } from "../mainViewComponent/Svg";
import { LabelIcons } from "../newDashboard/Svg/labelIcons";
import EnvironmentalMetrics from "./EnvironmentalMetrics";
import { HtmlTooltip, SubstancesIcons } from "../../constants";
import { getSubstabceConfiguration, getCategoryList } from "../../store/thunk/categorySubstanceThunk";
import { getAggMeasurements, GetDetailMeasurements, GetRelatedSubstancesThunk, getSubstanceThresholdsThunk } from "../../store/thunk/substanceThunk";
import { DetailSummary } from "./MainViewDetailsPage";
import moment from "moment";
import DetectionDetailsSkeleton from "../detectionComponent/detectionSkeleton/substanceTilesSkeleton";
import DashboardFacilitySkeleton from "./mainViewComponentSkeleton/DashboardFacilitySkeleton";
import { setNewDashboardLoader } from "../../store/slices/authSlice";
import { checkColorCode, findParents } from "../../helper/service";
import { useLocation } from "react-router-dom";
import { getEventList } from "../../store/thunk/eventMapThunk";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import StreetviewIcon from '@mui/icons-material/Streetview';
import {
  setDashboardInterval,
} from "../../store/slices/adminSlice";
import { locationList } from "../../store/slices/locationSlice";
import { updateDefaultLocationThunk } from "../../store/thunk/profile";
import { getSubstanceDetailList, setLoaderMeasurement } from "../../store/slices/substanceSlice";
import { userLocationInfoType } from "../common/LocationSelector";
import { getVerkadaDeviceData } from "../../store/thunk/thirdPartyDeviceThunk";
import ThirdPartyDeviceMetricCard from "./ThirdPartyDeviceMetricCard";

export const colorIndexData: any = {
  5: "#000000",
  4: "#871014",
  3: "#FFEF5C",
  2: "#FFEF5C",
  1: "#98E565",
  0: "#FFFFFF",
};

const facilityDataReducer = (state: any, action: any) => {
  switch (action.type) {
    case "SET_FACILITY":
      return action.payload;
    default:
      return state;
  }
};

export default function MainViewComponent(): JSX.Element {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { userData, newDashboardLoader } = useAppSelector((state) => state.authReducer);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [tenant, setTenant] = useState<any>(null);
  const [activeStep, setActiveStep] = useState<any>(1);
  const [tenantListDropdown, setTenantListDropdown] = useState([]);
  const { tenantDropDownList } = useAppSelector((state) => state.tenantSlice);
  const [selectedFacility, setSelectedFacility] = useState<any>(null);
  const [facilityDeviceData, setFacilityDeviceData] = useState<any>({});
  const [floorData, setFloorData] = useState<any>({});
  const [aggMeasureListNew, setAggMeasureListNew] = useState<any>([]);
  const [locationListOption, setLocationListOption] = useState<any>([]);
  const [variant, setVariant] = useState<any>("default");
  const [viewType, setViewType] = useState<any>("list");
  const [maxWrostData, setMaxWorstData] = useState<any>();
  const [substance, setSubstance] = useState<any>();
  const [substanceChange, setSubstanceChange] = useState<boolean>(false);
  const [roomLocationName, setRoomLocationName] = useState<any>([]);
  const [substanceLoc, setSubstanceLoc] = useState("");
  const [substanceDetailLocation, setSubstanceDetailLocation] = useState<any>({});
  const [relatedSubstanceData, setRelatedSubstanceData] = useState<any>([]);
  const [customLoader, setCustomLoader] = useState<boolean>(false);
  const [locationLoader, setLocationLoader] = useState<boolean>(true);
  const [deviceSubstanceColors, setDeviceSubstanceColors] = useState({});
  const [locationsList, setLocationsList] = useState<any>([]);
  const [floorWithRoomCounts, setFloorWithRoomCounts] = useState<any>([]);
  const [roomDeviceCountData, setRoomDeviceCountData] = useState<any>({});
  const [allReadingOfDevices, setAllReadingOfDevices] = useState<any>([]);
  const [floorDeviceCountForAcc, setFloorDeviceCountForAcc] = useState<any>({});
  const [eventMapTreeArray, setEventMapTreeArray] = useState<any>([]);
  const [locationsTreeArray, setLocationsTreeArray] = useState([]);
  const [relatedSubstancesLoader, setRelatedSubstancesLoader] = useState(false);
  const [facilityOption, setFacilityOption] = useState<any>([]);
  const [selectedValueFacility, setSelectedValueFacility] = useState<any>("");
  const [sideOverviewData, setSideOverviewData] = useState<any>({});
  const [mapViewType, setMapViewType] = useState<string>("2D");
  const [thirdPartySummary, setThirdPartySummary] = useState<any>(false);
  const [thirdPartyDeviceData, setThirdPartyDeviceData] = useState<any>({});
  const [deviceReading, setDeviceReading] = useState<any>();
  const [deviceReadingMetrics, setDeviceReadingMetrics] = useState<any>();
  const [metricsKey, setMetricsKey] = useState<any>();
  const [useLocationMainData, setUseLocationMainData] = useState<any>(
    location || {}
  );

  const { deviceWithWorstSubstanceData } = useAppSelector((state) => state.dashboardSlice);
  const { eventMapList } = useAppSelector((state) => state.eventMapSlice);

  const [dateRange, setDateRangeChange] = useState<any>({
    startDate: moment().startOf("minute").subtract(3, "hour"),
    endDate: moment().startOf("minute"),
  });
  const [request, setRequest] = useState({
    level: "",
    location: "",
    facilityKey: "",
  });
  const [currentFacilityData, dispatchCurrentFacilityData] = useReducer(
    facilityDataReducer,
    {} // initial state
  );
  const [currentFacilityDatas, setCurrentFacilityData] = useReducer(
    (state: any, action: any) => {
      if (action?.type === "FU") {
        return {
          ...action,
          children: [{ ...action, type: "L", parentKey: action?.key }],
        };
      }
      return action;
    },
    {}
  );
  const [disableMapView, setDisableMapView] = useReducer(
    (state: boolean, action: boolean) => {
      return !!currentFacilityData?.space_id ? false : action;
    },
    false
  );
  const locationData = useAppSelector(
    (store) => store?.locationSlice?.locationList?.getLocations
  );
  const { substanceConfigurationList, aggSubstanceList } = useAppSelector(
    (state: any) => state.substanceSlice
  );
  const { configureListNew } = useAppSelector(
    (state: RootState) => state.deviceSlice
  );

  const { eventLatestSubstanceList } = useAppSelector(
    (state) => state.eventMapSlice
  );
  const { measurementLoading, loading } = useAppSelector((store) => store?.substanceSlice);

  const { categoryList } = useAppSelector(
    (state) => state.categorySubstanceSlice
  );

  const { thirdPartyDeviceReading } = useAppSelector(
    (state) => state.thirdPartyDeviceSlice
  );

  const items = JSON.parse(localStorage.getItem("tenantId") || "{}");

  const currentFacilityRef = useRef<any>({});
  useEffect(() => {
    if (!currentFacilityData?.space_id) {
      setMapViewType("2D"); // Replace "RESET" with the default value
    }
  }, [currentFacilityData?.space_id]);
  useEffect(() => {
    currentFacilityRef.current = currentFacilityData;
  }, [currentFacilityData])
  //when there is no single uploaded floor plan image as per selected tenant then remove toggle switch buttons (List view - Map view)
  const hideToggleWhenNoEventMap = useCallback(() => {
    dispatch(
      getEventList({
        tenantCode:
          items && items?.tenantId ? items?.tenantCode : userData?.tenantCode,
      })
    ).then((res: any) => {
      const eventMaps = res?.payload;
      if (!eventMaps?.length && currentFacilityRef?.current?.type !== 'FU' && !currentFacilityRef?.current?.space_id) {
        setDisableMapView(true);
        setViewType("list");
      } else {
        setDisableMapView(false);
      }
    });
  }, [currentFacilityData, items]);

  //when there is no single uploaded event map floor plan image of selected facility then remove toggle switch buttons (List view - Map view)
  const setToggleEventMapAndFacilityWise = (facilityKey: any) => {
    let allEventMapFacId = eventMapList?.getEventMap?.map(
      (l: any) => l?.facility_id
    );
    allEventMapFacId = Array.from(new Set(allEventMapFacId));
    if (
      allEventMapFacId.includes(facilityKey) ||
      currentFacilityData?.type === "FU" ||
      !!currentFacilityData?.space_id
    ) {
      setDisableMapView(false);
    } else {
      setDisableMapView(true);
      setViewType("list");
    }
  };

  useEffect(() => {
    dispatch(getTenantDropDownList({}));
    if (items && items.tenantId) {
      dispatch(getCategoryList({ request: { tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode } }));
    }
    return () => {
      dispatch(setNewDashboardLoader(false));
      setCurrentFacilityData({});
    };
  }, []);

  useEffect(() => {
    if (tenant) {
      dispatch(getAllDevices({}));
      dispatch(
        getConfiguredDevicesNew({
          tenantCode:
            items && items.tenantId ? items.tenantCode : userData.tenantCode,
        })
      );
    }
  }, [tenant]);

  // Helper function: Get devices whose "loc" matches any room's "key"
  const getMatchingDevices = (rooms: any[], devices: any[]): any[] => {
    const roomKeys = new Set(rooms.map((room) => room.key));
    return devices.filter((device) => roomKeys.has(device.loc));
  };

  const mappedRoomAndDeviceCount = (data: any) => {
    return data.map((item: any) => {
      item.roomData = item.roomData?.map((item: any) => {
        const configuredDeviceCount = configureListNew?.filter(
          (x: any) => x.loc === item.key
        );
        return {
          ...item,
          deviceCount: configuredDeviceCount?.length || 0,
          device_keys: configuredDeviceCount?.map((x: any) => x?.sk),
        };
      });

      const floorDevices: any = item?.roomData?.flatMap(
        (item: any) => item?.device_keys
      );

      item.device_keys = floorDevices;
      return item;
    });
  };

  const getFloorAndRoomCounts = (data: any) => {
    const floors: any = {};
    function countRooms(parentKey: any) {
      let roomData: any = [];
      let roomCount = 0;
      data.forEach((item: any) => {
        if (item.parentKey === parentKey && item.type === "R") {
          roomData.push(item);
          roomCount++;
        }
        if (item.parentKey === parentKey && item.type === "U") {
          const [count, roomArr] = countRooms(item.key);
          roomCount += count;
          roomData.push(roomArr);
        }
      });
      return [roomCount, roomData.flat(2)];
    }

    data.forEach((item: any) => {
      if (
        ["L", "FU"]?.includes(item.type) /* item.type === "L" */ &&
        item.parentKey === currentFacilityData?.key
      ) {
        const floorKey = item.key;
        const [roomCount, roomData] = countRooms(floorKey);
        floors[floorKey] = { ...item, name: item.name, roomCount, roomData };
      }
    });

    const result = Object.values({ ...floors }).map((value: any) => {
      const data = {
        ...value,
        floorName: value.name,
        roomCount: value.roomCount,
      };
      // return Object.freeze(data);
      return data;
    });
    return Array.from(result);
  };

  const getMaxDataWithAllDeviceKeysAndCount = (data: any) => {
    const maxColorOrder = Math.max(
      ...data.map((entry: any) => entry.colorOrder)
    );

    const mergedDeviceKeys = data.reduce((acc: any, entry: any) => {
      acc.push(...entry.device_keys);
      return acc;
    }, []);

    const maxColorOrderEntries = data.filter(
      (entry: any) => entry.colorOrder === maxColorOrder
    );

    const object: any = {
      ...maxColorOrderEntries[0],
      device_keys: [...new Set(mergedDeviceKeys)],
      deviceCount: [...new Set(mergedDeviceKeys)]?.length,
    };

    // Use reduce to find the maximum colorOrder
    const maxColorOrderValue: any = object?.device_all_data
      ?.filter((x: any) => x.colorOrder)
      .reduce(
        (max: any, obj: any) => Math.max(max, obj?.colorOrder),
        Number.MIN_VALUE
      );

    const result = {
      ...object,
      colorOrder: maxColorOrderValue || 1,
    };

    return result;
  };

  const getDeviceWithWorstSubstance = async (requestData: any) => {
    await dispatch(getDeviceWithWorstSubstanceData({
      request:requestData,
      tenantCode:items && items?.tenantId ? items?.tenantCode : userData?.tenantCode
    }))
  }

  useEffect(() => {
    const isFacilityFU = currentFacilityData?.type === "FU";

    if (!currentFacilityData?.key) return;
    if (locationData?.length === 0) return;
    if (selectedFacility === null || selectedFacility === undefined || selectedFacility.value === "") return;
    setToggleEventMapAndFacilityWise(currentFacilityData?.key);
    let requestData = {
      facilityKey: currentFacilityData?.key,
      level: "fcl",
      location: currentFacilityData?.key,
    };
    try {
      if (isFacilityFU) {
        const roomsData = currentFacilityData?.children?.[0]?.children || [];
        const roomIds = roomsData.map((room: any) => room.key);
        const floorIds = roomsData.map((room: any) => room.floor_key);

        let facilityIds = locationData
          ?.filter((loc: any) => floorIds.includes(loc?.key))
          .map((loc: any) => loc?.parentKey) || [];

        facilityIds = Array.from(new Set(facilityIds));
        requestData = {
          facilityKey: facilityIds.join(","),
          level: "loc",
          location: roomIds.join(","),
        };
      }
      dispatch(setNewDashboardLoader(true));
      getDeviceWithWorstSubstance(requestData);
    } catch (error) {
      console.error("Error processing facility data:", error);
    }
  }, [selectedFacility?.value, locationData]);

  useEffect(() => {
    // if (deviceWithWorstSubstanceData.length === 0) return;
    let worstSubstanceDevice = deviceWithWorstSubstanceData
    const isFacilityFU = currentFacilityData?.type === "FU";
    console.log('deviceWithWorstSubstanceData 187845',{deviceWithWorstSubstanceData , currentFacilityData ,locationData} );
    if (!currentFacilityData?.key) return;
    if (locationData?.length === 0) return;
    if (selectedFacility === null || selectedFacility === undefined || selectedFacility.value === "") return;
    setToggleEventMapAndFacilityWise(currentFacilityData?.key);
    let selectedFloorNameWithCount: any = [];
    selectedFloorNameWithCount = getFloorAndRoomCounts([
      ...locationsList,
      currentFacilityData?.type === "FU"
        ? {
          ...currentFacilityData,
          type: "L",
          parentKey: currentFacilityData?.key,
        }
        : {},
    ]);
    setFloorWithRoomCounts(selectedFloorNameWithCount);
     
    const roomCountData: any = {};
    const roomAndDeviceCount = mappedRoomAndDeviceCount(
      selectedFloorNameWithCount
    );
    if (roomAndDeviceCount?.length) {
      const mappedDataForRoom: any = roomAndDeviceCount.flatMap(
        (item: any) => {
          return item?.roomData;
        }
      );

      mappedDataForRoom.map((x: any) => {
        roomCountData[x.key] = { deviceCount: x.deviceCount };
      });
    }
    const allDeviceReadings = worstSubstanceDevice?.flatMap((item: any) => ({
      index: item?.worstIndex,
      deviceId: item?.pDeviceId,
      location: item?.deviceId,
      worstIndex: item?.worstIndex,
    }));

    const facilityValue = selectedFacility?.value;
    console.log(selectedFacility, 'selectedFacility.value')
    const allData: any[] = Array.isArray(locationData) ? locationData : [];
    const devices: any[] = Array.isArray(configureListNew) ? configureListNew : [];

    let facilityDevices: any[] = [];
    let floors: any[] = [];

    if (isFacilityFU) {
      const roomsData = currentFacilityData?.children?.[0]?.children || [];
      facilityDevices = getMatchingDevices(roomsData, devices);
      floors = allData.filter(
        (item) => item.type === "FU" && item.key === facilityValue
      );
    } else {
      facilityDevices = devices.filter((item) => item.fcl === facilityValue);
      floors = allData.filter(
        (item) => item.type === "L" && item.parentKey === facilityValue
      );
    }

    const roomsData = allData.filter((item) => item.type === "R");

    console.log("roomsData ::", {roomsData, isFacilityFU, facilityDevices, floors, currentFacilityData, facilityValue, allData, devices});


    const floorsWithRooms = floors.map((floor: any) => {
      const associatedRooms = roomsData
        .filter((room) => room.parentKey === floor.key)
        .map((room) => {
          const roomDevices = isFacilityFU
            ? facilityDevices.filter((device: any) => device.loc === room.key)
            : floor.is_unit ? facilityDevices.filter(
              (device: any) => device.loc === room.key
            ) : facilityDevices.filter(
              (device: any) => device.flr === floor.key && device.loc === room.key
            );

          const devicesMapped = roomDevices.map((device: any) => {
            const filteredData = allDeviceReadings.find((reading: any) =>
              reading?.deviceId === device?.sk
            );
            const maxIndex = filteredData?.index || 0;
            return {
              name: device.location_name?.trim() || "",
              providerId: device?.providerId || "",
              provider: device?.provider,
              deviceId: device?.pk?.split("|")[1] || "",
              colorOrder: maxIndex,
            };
          });

          const roomColorOrder = devicesMapped.reduce(
            (max: number, d: any) => Math.max(max, d.colorOrder),
            0
          );

          const thirdPartyDevice = devicesMapped.length > 0 && devicesMapped.every((device: any) => device?.providerId.trim() !== "");


          return {
            ...room,
            devices: devicesMapped,
            thirdPartyDevice,
            statusCount: roomDevices.length,
            colorOrder: roomColorOrder,
          };
        });

      const totalStatusCount = associatedRooms.reduce((sum: any, item: any) => sum + item.statusCount, 0);
      const totalFloorDevices = isFacilityFU
        ? facilityDevices.filter((device: any) => device.stm === floor.parentKey).length
        : floor.is_unit ? totalStatusCount : facilityDevices.filter((device: any) => device.flr === floor.key).length

      const floorColorOrder = associatedRooms.reduce(
        (max: number, room: any) => Math.max(max, room.colorOrder),
        0
      );

      const thirdPartyDevice = associatedRooms.length > 0 && associatedRooms.every((room: any) => room?.thirdPartyDevice);

      return {
        ...floor,
        value: floor.key,
        name: floor.name,
        isUnit: floor.is_unit,
        type: floor.type,
        totalDevices: totalFloorDevices,
        totalRooms: associatedRooms.length,
        rooms: associatedRooms,
        thirdPartyDevice,
        colorOrder: floorColorOrder,
      };
    });

    const facilityColorOrder = floorsWithRooms.reduce(
      (max: number, floor: any) => Math.max(max, floor.colorOrder),
      0
    );

    const allConfiguredDevices: any = configureListNew?.map(
      (x: any) => x?.pk?.split("|")?.[1]
    );
    worstSubstanceDevice = worstSubstanceDevice?.filter((x: any) =>
      allConfiguredDevices?.includes(x.deviceId)
    );
    const allDeviceReadingData = worstSubstanceDevice?.flatMap((item: any) => ({
      index: item?.worstIndex,
      deviceId: item?.pDeviceId,
      location: item?.deviceId,
      worstIndex: item?.worstIndex,
    }));

    setAllReadingOfDevices(allDeviceReadingData);

    const floorDeviceData: any = {};
    const sideBarOverviewData: any = {};

    roomAndDeviceCount.map((parentItem: any) => {
      // room level data
      parentItem.roomData = [
        ...new Map(
          parentItem?.roomData?.map((neX: any) => [neX.key, neX])
        ).values(),
      ].sort((a: any, b: any) => a.ixb - b.ixb);
      parentItem.roomData = parentItem?.roomData?.map((item: any) => {
        const filteredData = allDeviceReadingData.filter(
          (childItem: any) =>
            item?.device_keys?.includes(childItem?.deviceId)
        );
        const numbersArray = filteredData.map((obj: any) => obj?.index);
        const maxNumber = Math.max(...numbersArray);
        item.colorOrder = maxNumber;
        roomCountData[item.key] = {
          ...roomCountData[item.key],
          colorOrder: maxNumber,
          // colorOrder: 4,
          parentKey: item?.parentKey,
          device_keys: item?.device_keys,
        };

        const finalMergedDataForRoom = item?.device_keys
          ?.map((deviceKey: any) => {
            const findedReadings = allDeviceReadingData?.find(
              (xItem: any) => xItem?.deviceId === deviceKey
            );
            return {
              key: deviceKey,
              colorOrder: findedReadings?.index,
            };
          })
          ?.sort((a: any, b: any) => b.colorOrder - a.colorOrder);

        item.device_all_data = finalMergedDataForRoom;
        roomCountData[item.key]["device_all_data"] =
          finalMergedDataForRoom;

        return item;
      });

      const deviceListForSideView = parentItem?.roomData?.flatMap(
        (x: any) => x?.device_keys
      );

      // Side over data
      const finalMergedData = deviceListForSideView
        ?.map((deviceKey: any) => {
          const findedReadings = allDeviceReadingData?.find(
            (xItem: any) => xItem?.deviceId === deviceKey
          );
          return {
            key: deviceKey,
            colorOrder: findedReadings?.index,
          };
        })
        ?.sort((a: any, b: any) => b.colorOrder - a.colorOrder);

      sideBarOverviewData[parentItem?.key] = finalMergedData;

      //Floor Level Data
      floorDeviceData[parentItem?.key] = parentItem?.roomData
        ?.map((item: any) => {
          return {
            ...item,
            deviceCount: item?.deviceCount,
            colorOrder: item?.colorOrder,
            // colorOrder: 4,
            parentKey: parentItem?.parentKey,
          };
        })
        ?.filter((x: any) => x.device_keys?.length)
        ?.sort((a: any, b: any) => b.colorOrder - a.colorOrder);
      parentItem["allRoomDeviceCount"] = [
        ...new Map(
          floorDeviceData[parentItem.key]?.map((x: any) => [x.key, x])
        ).values(),
      ];
    });

    const newDataForListAcc: any = {};
    Object.keys(floorDeviceData).map((xcd: any) => {
      const finalData = getMaxDataWithAllDeviceKeysAndCount(
        floorDeviceData[xcd]
      );
      newDataForListAcc[xcd] = [finalData];
    });

    // Unit level calculations
    // const mappedUnitDeviceData = roomAndDeviceCount
    //   ?.filter((x: any) => x?.is_unit)
    //   .flatMap((x: any) => x.allRoomDeviceCount)
    //   ?.filter((x: any) => x?.device_keys?.length)
    //   ?.sort((a: any, b: any) => b.colorOrder - a.colorOrder);

    // const unitLevelData =
    //   getMaxDataWithAllDeviceKeysAndCount(mappedUnitDeviceData);

    // setUnitDeviceCount([{ ...unitLevelData }]);
    // setAllfclandFlrData([...roomAndDeviceCount]);
    setFloorDeviceCountForAcc({ ...newDataForListAcc });
    setSideOverviewData({ ...sideBarOverviewData });
    // setFacilityDeviceCount([{ ...facilityLevelData }]);
    // setFloorDeviceCount({ ...floorDeviceData });
    setRoomDeviceCountData({
      ...roomCountData,
    });

    const facilityDevice = (floorsWithRooms ?? []).reduce((total: any, item: any) => {
      return !item?.isUnit ? total + (item?.totalDevices || 0) : total;
    }, 0);

    setFloorData(floorsWithRooms);
    setFacilityDeviceData((prev: any) => ({
      ...prev,
      facilityDevicesTotal: isFacilityFU ? facilityDevices.length : facilityDevice,
      facilityColorOrder: facilityColorOrder,
    }));    
  }, [deviceWithWorstSubstanceData, currentFacilityData])
  useEffect(() => {
    if (!locationData || locationData.length === 0) {
      setLocationListOption([]);
      return;
    }

    const options = locationData
      .filter((item: any) => item?.type === "F" || item?.type === "FU")
      .map((item: any) => ({
        ...item,
        value: item.key,
        label: item.name,
      }));

    if (userData?.username && !selectedFacility && options.length > 0) {
      const location_info = JSON.parse(userData?.location_info || "{}") as userLocationInfoType;
      const storedLocation = locationData?.find((i: any) => i?.key === location_info?.facility);
      // const storedLocation = localStorage.getItem("default_location");

      let parsedLocation: any;
      if (storedLocation) {
        // parsedLocation = JSON.parse(storedLocation);
        parsedLocation = { ...storedLocation, value: storedLocation?.key, label: storedLocation?.name };
      }
      const facility: any = parsedLocation || options[0]
      setSelectedFacility(facility);
      handleChangeFacility(null, facility);
    }

    setLocationListOption(options);
    console.log('dispatchCurrentFacilityData 1', options);  
    dispatchCurrentFacilityData({ type: "SET_OPTIONS", payload: options });
  }, [locationData, JSON.stringify({ username: userData?.username, location: userData?.location_info })]);
  const defaultProps = {
    options: tenantDropDownList.getTenants
      ? tenantDropDownList?.getTenants.tenants
      : [],
    getOptionLabel: (option: any) => option.tenant_name,
  };

  const handleChangeTenant = async (event: any, value: any) => {
    if (!value?.tenantCode) return;

    try {
      // Await the API call
      setTenant(value);
      dispatch(setTenantId(value));
      setVariant("default");
      setViewType("list");
      setActiveStep(1);
      setLocationLoader(true);
      dispatch(locationList([{}]));
      setSelectedFacility(null);
      // dispatch(configureListNew([]));
      const tenantData = tenantDropDownList?.getTenants?.tenants;
      const currentTenant = tenantData?.find(
        (item: any) => item?.tenantId == value?.tenantId
      );

      dispatch(getCategoryList({ request: { tenantCode: currentTenant?.tenantCode } }));
      await dispatch(getLocationLists({ tenantId: value.tenantCode })).unwrap();
      setLocationLoader(false);
    } catch (error) {
      setLocationLoader(false);
      console.error("Error fetching location lists:", error);
    }
  };


  const handleChangeFacility = (event: any, value: any) => {
    if (value?.key === selectedFacility?.key) return;
    setFacilityDeviceData({});
    setFloorData({});

    // If the selected facility is of type "FU"
    if (value?.type === "FU") {

      // Compute the rooms for this facility from locationData:
      const facilityRooms = locationData.filter(
        (item: any) => item.parentKey === value.key && item.type === "R"
      );
      const selectedFacility: any = facilityOption.find(
        (x: any) => x.key === event.target.value
      );
      setCurrentFacilityData(selectedFacility);

      // Attach the rooms in a nested structure as expected by your request-building code:
      const newValue = {
        ...value,
        children: [{ children: facilityRooms }],
      };
      console.log('dispatchCurrentFacilityData 2');
      dispatchCurrentFacilityData({ type: "SET_FACILITY", payload: newValue });
      setSelectedFacility(newValue);
    } else {
      console.log('dispatchCurrentFacilityData 3');
      dispatchCurrentFacilityData({ type: "SET_FACILITY", payload: value });
      setSelectedFacility(value);
    }
    // const facility = locationData?.find((loc: any) => loc?.key === value?.key);
    const requestLocationInfo = {
      // system: facility?.parentKey,
      // facility: facility?.key,
      facility: value?.key,
    }
    dispatch(storeUserLocationDetailsMutationThunk({ username: userData?.username, location_info: requestLocationInfo }))

    // const defaultLocationObj = {
    //   // userid: tenant.,
    //   default_type: "fcl",
    //   default_location: value,
    // };
    // localStorage.setItem("default_location", JSON.stringify(defaultLocationObj.default_location)); // Store as a string

  };

  useEffect(() => {
    let obj: any = {
      name: userData.name,
      tenantCode: userData.tenantCode,
      tenantId: userData.tenantId,
    };
    let request = {
      tenantId:
        items && items.tenantId ? items.tenantCode : userData.tenantCode,
    };
    if (userData.tenantId) {
      setLocationLoader(true);
      dispatch(getLocationLists(request))
        .unwrap()
        .then(() => {
          setLocationLoader(false); // Stop loading after API success
        })
        .catch((error) => {
          console.error("Error fetching location lists:", error);
          setLocationLoader(false); // Ensure loader stops even on failure
        });
      dispatch(getSubstabceConfiguration({ tenantCode: (userData.tenantCode) }))
      dispatch(getCategoryList({ request: { tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode } }));
      setTenant(obj);
    } else {
      if (!__.isEmpty(userData?.tenant_info)) {
        const lastTenantInfo = JSON.parse(userData?.tenant_info);
        setTenant(lastTenantInfo);
        let request = {
          tenantId: lastTenantInfo.tenantCode,
        };

        if (locationData === undefined || locationData.length === 0) {
          setLocationLoader(true);
          dispatch(getLocationLists(request))
            .unwrap()
            .then(() => {
              setLocationLoader(false); // Stop loading after API success
            })
            .catch((error) => {
              console.error("Error fetching location lists:", error);
              setLocationLoader(false); // Ensure loader stops even on failure
            });
        }
        dispatch(getSubstabceConfiguration({ tenantCode: (lastTenantInfo.tenantCode) }))
      }
    }
    hideToggleWhenNoEventMap();
  }, [userData]);

  useEffect(() => {
    if (
      tenantDropDownList &&
      tenantDropDownList.getTenants &&
      tenantDropDownList?.getTenants?.tenants.length
    ) {
      setTenantListDropdown(tenantDropDownList?.getTenants?.tenants);
    }
  }, [tenantDropDownList]);

  useEffect(() => {
    if (substanceConfigurationList.length > 0 && aggSubstanceList.length > 0) {
      let getNoDataTiles: any = [];
      let latestArr = substanceConfigurationList.map((item: any) => {
        const config =
          (aggSubstanceList.length > 0 &&
            aggSubstanceList[0].readings.find(
              (val: any) =>
                val.substanceKey === item.substanceKey ||
                (val.substanceKey === "pm10" && item.substanceKey === "pm10m")
            )) ||
          undefined;
        let color = "#C7C6C1";
        let value = null;
        let value1 = null;
        let count = "0";
        let icon = SubstancesIcons[item.substanceKey] || "Cloud_light";
        let trend = "";
        let isoIndex = "-";
        let index = "0";
        if (config !== undefined) {
          color = config?.color || "#C7C6C1";
          value = config?.value;
          value1 = config?.value1;
          count = config?.count;
          trend = config?.trend;
          isoIndex = config?.isoIndex;
          index = config?.index;
          return {
            ...item,
            color: color,
            value: value,
            value1: value1,
            count: count,
            trend: trend,
            icon: icon,
            isoIndex,
            index,
          };
        } else {
          const itemObj = {
            ...item,
            color: color,
            value: value,
            value1: value1,
            count: count,
            trend: trend,
            isoIndex,
            index,
          };
          getNoDataTiles.push(itemObj);
        }
      });

      latestArr = latestArr.filter(
        (l: any) =>
          typeof l !== "undefined" &&
          l.substanceKey !== "pm1" &&
          l.group !== "pm1"
      );
      getNoDataTiles = getNoDataTiles.filter((l: any) => l?.order_no !== "0");

      if (JSON.stringify(aggMeasureListNew) !== JSON.stringify(latestArr)) {
        //If
        const tempLatestArr = latestArr.map((l: any) => {
          return {
            ...l,
            value: l?.value < 0 ? 0 : l?.value,
          };
        });

        setAggMeasureListNew(tempLatestArr);
      }
      // if (
      //   JSON.stringify(noDataAggMeasureListNew) !==
      //   JSON.stringify(getNoDataTiles)
      // ) {
      //   setNoDataAggMeasureListNew(getNoDataTiles);
      // }
    } else {
      setAggMeasureListNew([]);
    }
  }, [aggSubstanceList, substanceConfigurationList]);

  useEffect(() => {
    if (substance) {
      if (!substance?.substanceKey) return;
      const substanceKey = substance?.substanceKey;

      if (selectedFacility !== "") {
        setRelatedSubstancesLoader(true)
        let request: any = {};
        if (currentFacilityData?.type === "FU") {
          const roomsData = currentFacilityData?.children[0]?.children || [];
          const room = roomsData?.find(
            (value: any) => value?.key === substanceLoc
          );
          let floor = locationData?.find(
            (value: any) => room?.floor_key === value?.key
          );
          request = {
            level: "fcl",
            location: floor?.parentKey,
            facilityKey: floor?.parentKey,
            substanceKey: substanceKey,
            count: 5,
          };
        } else {
          request = {
            level: "fcl",
            location: currentFacilityData?.key,
            facilityKey: currentFacilityData?.key,
            substanceKey: substanceKey,
            count: 5,
          };
        }

        const relatedSubstanceCall = () => {
          dispatch(GetRelatedSubstancesThunk(request))
            .then((res) => {
              let relatedSubstanceData = res?.payload || [];
              if (relatedSubstanceData && relatedSubstanceData?.length) {
                relatedSubstanceData = relatedSubstanceData.filter(
                  (x: any) => x.location !== "NA"
                );

                //Remove Duplicates substanceKey data
                relatedSubstanceData = [
                  ...new Map(
                    relatedSubstanceData?.map((x: any) => [x.substanceKey, x])
                  ).values(),
                ];

                // Group data by location
                const groupedData = relatedSubstanceData.reduce(
                  (acc: any, obj: any) => {
                    const { location, ...rest } = obj;
                    if (!acc[location]) {
                      acc[location] = [];
                    }
                    const getSubstanceColor = colorIndexData[rest?.index];
                    const config = substanceConfigurationList.find(
                      (val: any) => val.substanceKey === rest?.substanceKey
                    );
                    if (typeof config !== "undefined") {
                      const allProps = {
                        ...rest,
                        color: getSubstanceColor,
                        unit: config?.unit,
                        trend: rest?.trend || "",
                        substance: config?.displayName,
                        displayName: config?.displayName,
                        providers: config?.providers,
                        count: 0,
                      };
                      acc[location].push(allProps);
                    }
                    return acc;
                  },
                  {}
                );

                // Convert grouped data into an array of objects
                let result = Object.entries(groupedData)
                  .map(([location, substances]) => {
                    const getRoomData = locationData.find(
                      (l: any) => l?.key === location && l?.type === "R"
                    );
                    if (!__.isEmpty(getRoomData)) {
                      //If room is not undefined
                      const locationName = `${getRoomData?.name}`;
                      return {
                        roomData: getRoomData,
                        location,
                        locationName,
                        substances,
                      };
                    }
                    return null;
                  })
                  .filter((item) => item !== null);
                if (currentFacilityData?.type === "FU") {
                  // show only facility group room related data
                  const facilityGroupRoomIds = currentFacilityData?.children?.[0]?.children?.map((value: { key: string }) => value?.key);
                  result = result?.filter((value: any) => facilityGroupRoomIds?.includes(value?.location));
                }
                setRelatedSubstanceData(result);
                setRelatedSubstancesLoader(false)
              } else {
                setRelatedSubstanceData([]);
                setRelatedSubstancesLoader(false)
              }
            })
            .catch(() => {
              setRelatedSubstancesLoader(false)
            });
        };
        relatedSubstanceCall();
      }
    }
  }, [substance]);

  useEffect(() => {
    if (thirdPartyDeviceReading && Object.keys(thirdPartyDeviceReading).length !== 0) {
      setDeviceReading((prevState: any) =>
        JSON.stringify(prevState) !== JSON.stringify(thirdPartyDeviceReading)
          ? thirdPartyDeviceReading
          : prevState
      );
    }
  }, [thirdPartyDeviceReading]);


  const handleStepFunction = (value: any) => {

    dispatch(getSubstanceDetailList([]));
    setSubstance("")
    setActiveStep(value + 1);
    setSubstanceChange(false);
  };

  const handleToggle = (_event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
    if (newValue !== null) {
      setVariant(newValue);
    }
  };

  function toUnixTimestamp(isoString: any) {
    return Math.floor(new Date(isoString).getTime() / 1000);
  }

  const handleGetSummaryData = async (level: any, location: any) => {
    console.log("handleGetSummaryData ::", level, location);
    try {
      setActiveStep(2);
      setThirdPartySummary(false);
      const allData: any[] = Array.isArray(locationData) ? locationData : [];
      const facility: any = allData.filter((item) => item.key === location);

      // Prepare the base request
      let baseRequest: any = {}
      if (facility[0].is_unit) {
        const roomsData = allData.filter((item) => item.type === "R");
        const associatedRooms = roomsData.filter((room) => room.parentKey === location)
        const roomIds = associatedRooms.map((room: any) => room.key);
        baseRequest = {
          level: "loc",
          location: roomIds.join(","),
          facilityKey: selectedFacility.key,
          tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode
        };
      } else {
        baseRequest = {
          level: level,
          location: location || selectedFacility.key,
          facilityKey: selectedFacility.key,
          tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode
        };
      }

      let requestData = baseRequest;
      const isFacilityFU = currentFacilityData?.type === "FU";

      if (isFacilityFU) {
        // Find the selected location object from locationData based on the provided key.
        const selection = locationData?.find((item: any) => item.key === location);

        // Determine roomsData:
        // If the selection exists and its type is either "FU" or "L", use the children data from currentFacilityData.
        // Otherwise, if a selection exists, wrap it in an array; if not, use an empty array.
        const roomsData = selection && ["FU", "L"].includes(selection.type)
          ? currentFacilityData?.children?.[0]?.children || []
          : currentFacilityData?.children?.[0]?.children?.filter((item: any) => item.key === location);

        // Extract roomIds and floorIds from roomsData.
        const roomIds = roomsData.map((room: any) => room.key);
        const floorIds = roomsData.map((room: any) => room.floor_key);

        // Identify unique facility IDs by filtering locationData with matching floor IDs.
        const facilityIds = Array.from(
          new Set(
            locationData
              ?.filter((loc: any) => floorIds.includes(loc.key))
              .map((loc: any) => loc.parentKey)
          )
        );
        requestData = {
          facilityKey: facilityIds.join(","),
          level: "loc",
          location: roomIds.join(","),
          tenantCode: items && items.tenantId ? items.tenantCode : userData.tenantCode          
        };
      }


      // Update state with the final request data
      setRequest(requestData);
      setCustomLoader(true);

      // Dispatch the action and await its result
      await dispatch(getAggMeasurements(requestData));
    } catch (error) {
      setCustomLoader(false);
      console.error("Error fetching summary data:", error);
    }
  };

  const handleGetThirdPartyDeviceMetrics = async (metricsKey: any) => {

    console.log("metricsKey ::", metricsKey);
    const response = await dispatch(getVerkadaDeviceData({
      deviceId: thirdPartyDeviceData?.deviceId,
      per_page: "50",
      providerId: thirdPartyDeviceData?.providerId,
      end_time: toUnixTimestamp(dateRange.endDate),
      fields: metricsKey,
      interval: "60s",
      start_time: toUnixTimestamp(dateRange.startDate),
    }));
    setMetricsKey(metricsKey)
    setDeviceReadingMetrics(response?.payload || [])
    setActiveStep(3);

  }

  const handleGetDetailMeasurements = async (data: any, substanceLoc?: any, isRelatedData?: any) => {
    setCustomLoader(true);
    setRelatedSubstanceData([]);
    setActiveStep(3);

    let requestForDetail: any = {};

    if (isRelatedData) {
      // const level: any = getLevelKey();
      let facilityKey = currentFacilityData?.key;
      if (currentFacilityData?.type === "FU") {
        const floor = locationData?.find((value: any) => value?.key === isRelatedData.parentKey);
        const facility = locationData?.find((value: any) => value?.key === floor?.parentKey);
        facilityKey = facility?.key;
        // setCurrentFacilityData(facility);        
      }
      requestForDetail = {
        level: "flr",
        location: isRelatedData.parentKey,
        facilityKey: facilityKey,

      };
      setRequest(requestForDetail);
    } else {
      requestForDetail = {
        ...request
      }
    }
    dispatch(GetDetailMeasurements(requestForDetail)).then((res: any) => {

      let payloadData = res?.payload || [];
      if (payloadData && payloadData?.length) {
        const getAllRoomLocationIds = locationData
          ?.filter((l: any) => l?.type === "R")
          ?.map((l: any) => l?.key);

        const roomLocation: any = [];
        //Prepare for room location dropdown, find room name with room prefix dynamically
        payloadData.map((p: any) => {
          const roomLoc = p?.location;

          const getRoom = locationData?.find(
            (l: any) => l?.type === "R" && l?.key === roomLoc
          );

          const getFloorKey = getRoom?.parentKey || "";

          if (getFloorKey) {
            let getRoomData: any = [];
            if (currentFacilityDatas?.type === "FU") {
              getRoomData = (
                currentFacilityDatas?.children?.[0]?.children || []
              )?.filter((l: any) => l?.key === roomLoc);
            } else {
              getRoomData =
                currentFacilityDatas?.children
                  ?.find((l: any) => l.key === getFloorKey)
                  ?.children?.filter((l: any) => l?.key === roomLoc) || "";
            }

            roomLocation.push({
              roomLocationId: roomLoc,
              roomLocationName: getRoom?.name,
            });
          }
        });


        setRoomLocationName(roomLocation); //setting room location data

        payloadData = payloadData.filter((l: any) =>
          getAllRoomLocationIds.includes(l?.location)
        );

        const allTheReadings = payloadData?.flatMap((item: any) => {
          const maxRead = item?.readings
            ?.slice()
            ?.filter((x: any) => x.substanceKey === data.substanceKey)
            ?.sort((a: any, b: any) => b?.index - a?.index)?.[0];

          return {
            ...item,
            readings: maxRead,
          };
        });

        const maxWorstData = allTheReadings
          ?.slice()
          ?.filter((l: any) => l?.readings && Object.keys(l?.readings).length)
          ?.sort((a: any, b: any) => b?.readings?.index - a?.readings?.index)
          ?.sort(
            (a: any, b: any) => b?.readings?.value - a?.readings?.value
          )?.[0];

        setMaxWorstData(maxWorstData);
        let substanceValue: any;
        //When there is no data from any room location for selected substance
        if (typeof maxWorstData === "undefined") {
          const substanceData = {
            ...data,
            substance: data?.displayName,
          };
          substanceValue = substanceData;
          setSubstance(substanceData);
        }

        const roomData = locationData?.find(
          (value: any) =>
            value?.key ===
            (locationData || roomLocation?.[0]?.roomLocationId) &&
            !value?.floor_key
        );
        const floorData = locationData?.find(
          (value: any) => value?.key === roomData?.parentKey
        );
        const requestThreshold = {
          facilityKey: floorData?.parentKey,
        };
        dispatch(getSubstanceThresholdsThunk(requestThreshold));

        let roomLocationId = "";
        //When User Selected Substance from Related Substance then there is locationData value
        if (substanceLoc) {
          roomLocationId = substanceLoc;
          let getReadings;

          //get readings of selected substance of selected room location
          payloadData.map((obj: any) => {
            if (obj.location === roomLocationId) {
              const readings = obj.readings.find(
                (reading: any) => reading.substanceKey === data.substanceKey
              );
              getReadings = readings;
            }
          });
          if (getReadings) {
            substanceValue = getReadings;
            setSubstance(getReadings);
            if (JSON.stringify(maxWorstData) !== JSON.stringify(getReadings)) {
              setMaxWorstData(getReadings);
            }
          }
        } else {
          //When User selected substance from Summary screen
          if (dateRange !== null && maxWorstData?.location) {
            roomLocationId = maxWorstData?.location || "";
            substanceValue = maxWorstData?.readings;
            setSubstance(maxWorstData?.readings);
            setMaxWorstData(maxWorstData);
          }
        }

        setSubstanceLoc(roomLocationId);

        const getWorstLocation = payloadData.filter(
          (l: any) => l?.location === roomLocationId
        );
        const NewArr = {
          data: getWorstLocation,
          Fname: "",
          Lname: "",
          Uname: "",
          facility: currentFacilityData?.key,
          floor: "",
        };
        const hhData: any = [];
        NewArr?.data?.[0]?.readings?.filter((item: any) => {
          const substanceData = substanceConfigurationList.find(
            (sub: any) =>
              (sub.group !== sub?.substanceKey &&
                item.substanceKey == sub.substanceKey) ||
              (sub.group === "thi" && item.substanceKey == sub.substanceKey) ||
              (sub.group === "pc_bioi" &&
                item.substanceKey == sub.substanceKey) ||
              (sub.group === "pc_bio" &&
                item.substanceKey == sub.substanceKey) ||
              (sub.group === "pc_biop" && item.substanceKey == sub.substanceKey)
          );
          if (substanceData) {
            hhData.push({ ...item, displayName: substanceData?.displayName });
          }
        });
        setSubstanceDetailLocation({
          ...NewArr,
          data: [{ ...NewArr?.data?.[0], readings: hhData }],
        });

      } else {
        setCustomLoader(false);
        setMaxWorstData({});
      }
    }).catch((err) => {
      setCustomLoader(false);
    });
  };

  const handleChangeLocation = async (event: any) => {
    setSubstanceLoc(event.target.value);
    setSubstanceChange(true);
    await handleGetDetailMeasurements(substance, event.target.value);
  };

  const handleChangeSubstance = async (event: any) => {
    const selectedValue = event.target.value;
    const selectedValue2 = substanceDetailLocation?.data?.[0]?.readings?.find(
      (x: any) => x.substanceKey === selectedValue
    );

    setSubstanceChange(true);
    setSubstance(selectedValue2);
    await handleGetDetailMeasurements(selectedValue2, substanceLoc);
  };

  useEffect(() => {
    if (selectedFacility?.key) {
      if (items?.tenantId) {
        dispatch(
          getEventList({
            tenantCode:
              items && items?.tenantId
                ? items?.tenantCode
                : userData?.tenantCode,
          })
        );
      }
    }
  }, [selectedFacility]);

  useEffect(() => {
    const maxValuesByDeviceIdNew: any = {};
    if (eventLatestSubstanceList?.length) {
      eventLatestSubstanceList.forEach((item: any) => {
        const { device, index } = item;
        if (
          !maxValuesByDeviceIdNew[device] ||
          Number(index) > Number(maxValuesByDeviceIdNew[device])
        ) {
          maxValuesByDeviceIdNew[device] = Number(index);
        }
      });
    }
    setDeviceSubstanceColors(maxValuesByDeviceIdNew);
  }, [eventLatestSubstanceList]);

  function findParentsReplaceindex(item: any, data: any) {
    let currentKey = item.parentKey;
    while (currentKey) {
      const parent = data.find((item: any) => item.key === currentKey);
      if (!parent) break; // If parent not found, exit loop
      if (parent.colorIndex < item.colorIndex) {
        parent["fillColor"] = item.fillColor;
        parent["colorIndex"] = item.colorIndex;
      }
      const indexElement = data.findIndex(
        (item: any) => item.key === currentKey
      );
      data[indexElement] = parent;
      currentKey = parent.parentKey;
    }
    return data;
  }

  const buildHeirchy = (data: any) => {
    const finalData: any = [];
    for (const item of data) {
      if (["F", "FU"].includes(item?.type)) {
        const allChildren = data?.filter((x: any) => x.parentKey === item?.key);
        if (allChildren?.length) {
          for (const [index, childItem] of allChildren.entries()) {
            const nestedChildrens = data?.filter(
              (x: any) => x.parentKey === childItem?.key
            );
            if (nestedChildrens?.length) {
              allChildren[index].children = [...nestedChildrens]?.map(
                (xy: any) => ({ ...xy, children: [] })
              );
            } else {
              allChildren[index].children = [];
            }
          }
        } else {
          item.children = [];
        }
        finalData.push({
          ...item,
          children: [...allChildren],
        });
      }
    }
    return finalData;
  };

  useEffect(() => {
    if (locationData) {
      let color: any = deviceSubstanceColors;
      let changeSubstanceColor: any = [];
      let newLocationArr = locationData
        ?.filter((row: any) => row.type !== "S")
        .map((itms: any) => {
          let device = "";
          let colorIndex = "";
          let fillColor = "#98E565";
          let message = "Device Id: <br/>";
          if (configureListNew?.length) {
            const avaibleDevice = configureListNew.filter(
              (i: any) => i.loc === itms.key
            );
            if (avaibleDevice?.length > 0) {
              const maxValuesByDeviceIdNew: any = {};
              if (avaibleDevice?.length) {
                avaibleDevice.forEach((item: any) => {
                  const { pk } = item;
                  message += pk.replace("D|", "") + "<br/>";
                  if (
                    !maxValuesByDeviceIdNew[pk.replace("D|", "")] ||
                    Number(color[pk.replace("D|", "")]) >
                    Number(maxValuesByDeviceIdNew[pk.replace("D|", "")])
                  ) {
                    maxValuesByDeviceIdNew[pk.replace("D|", "")] = Number(
                      color[pk.replace("D|", "")]
                    );
                  }
                });
              }
              let max = [];
              if (Object.keys(maxValuesByDeviceIdNew)?.length > 0) {
                max = Object.entries(maxValuesByDeviceIdNew).reduce(
                  (max: any, entry: any) => (entry[1] >= max[1] ? entry : max),
                  ["", -Infinity]
                );
              }
              if (Object.keys(deviceSubstanceColors)?.length && color[max[0]]) {
                fillColor = checkColorCode(color[max[0]]);
                colorIndex = color[max[0]];
                changeSubstanceColor.push({
                  ...itms,
                  device: device,
                  colorIndex: colorIndex,
                  fillColor: fillColor,
                  message: message,
                });
              }
              device = avaibleDevice[0].pk.replace("D|", "");
            }
          }
          return {
            ...itms,
            device: device,
            colorIndex: colorIndex,
            fillColor: fillColor,
            message: message,
          };
        });

      var result = Object.values(
        changeSubstanceColor.reduce(function (r: any, e: any) {
          if (!r[e.parentKey] && !r[e.loc]) r[e.parentKey] = e;
          else if (e.colorIndex > r[e.parentKey].colorIndex) r[e.parentKey] = e;
          return r;
        }, {})
      );

      result.map((item: any) => {
        newLocationArr = findParentsReplaceindex(item, newLocationArr);
      });

      //==================== My code to add prefix START ====================
      const treeMap = buildHeirchy(newLocationArr);
      treeMap?.map((fcl: any, idxFcl: number) => {
        fcl.prefix = "FA" + (idxFcl + 1); //Facility Label

        const flrArr = [];
        const dptArr = [];
        fcl?.children?.map((flr: any, idxFlr: number) => {
          let prefix = "";
          if (flr.is_unit === false || flr.is_unit === null) {
            flrArr.push(flr);
            prefix = `FL${flrArr?.length}`;
          } else if (flr.is_unit === true) {
            dptArr.push(flr);
            prefix = `D${dptArr?.length}`;
          }

          flr.prefix = prefix; //Floor or Department Label

          flr?.children.map((room: any, idxRoom: number) => {
            room.prefix = "RM" + (idxRoom + 1); //Room Label
            room.ixb = idxRoom + 1;
          });
        });
      });

      const flattenChildren = (arr: any): any => {
        const result: any = [];
        arr.forEach(({ children, ...rest }: any) => {
          result.push({ ...rest });
          if (children) {
            result.push(...flattenChildren(children));
          }
        });
        return result;
      };

      const flattenedData: any = flattenChildren(treeMap);
      //==================== My code to add prefix END ====================

      // setLocationsList(newLocationArr);
      setLocationsList(flattenedData);
    }
  }, [locationData]);

  useEffect(() => {
    const treeMap = buildHeirchy(locationsList);
    // const floorWithRoomCount = getFloorAndRoomCounts(locationsList);
    // setFloorWithRoomCounts(floorWithRoomCount);
    setLocationsTreeArray(treeMap);
    if (locationsTreeArray?.length) {
      getDataEmap(locationsTreeArray[0]);
    } else {
      setEventMapTreeArray([]);
    }
  }, [locationsList]);

  const getDataEmap = (data: any) => {
    setEventMapTreeArray([data]);
  };

  useEffect(() => {
    if (locationsTreeArray) {


      const filteredFacilities: any = locationsTreeArray?.filter((item: any) =>
        ["F", "FU"].includes(item.type)
      );
      setFacilityOption(filteredFacilities);
      if (useLocationMainData?.state?.notificationData?.facilityKey) {
        const filteredFacilitiesExists: any = filteredFacilities?.find(
          (item: any) =>
            item.key ===
            useLocationMainData?.state?.notificationData?.facilityKey
        );
        setSelectedValueFacility(filteredFacilitiesExists?.key);
        // setSelectedFacility(parsedLocation);
        setCurrentFacilityData(filteredFacilitiesExists);
      } else if (currentFacilityData?.key) {
        const filteredFacilitiesExists: any = locationsTreeArray?.find(
          (item: any) => item.key === currentFacilityData?.key
        );
        setSelectedValueFacility(filteredFacilitiesExists?.key);
        // setSelectedFacility(parsedLocation);
        setCurrentFacilityData(filteredFacilitiesExists);
      } else {
        let defaultFacility = filteredFacilities?.[0]?.key;
        let defaultFacilityData = filteredFacilities[0];
        //Get and Set User Last selected Facility as Default Facility

        const getDefaultLocation =
          userData?.default_location;
        if (getDefaultLocation) {
          const userDBDefaultFacility = getDefaultLocation;
          const isFacilityExist = filteredFacilities.filter(
            (l: any) => l?.key === userDBDefaultFacility
          );
          if (isFacilityExist.length) {
            defaultFacility = userDBDefaultFacility;
            defaultFacilityData = isFacilityExist[0];
          }
        }
        setSelectedValueFacility(defaultFacility);
        // setSelectedFacility(parsedLocation);
        setCurrentFacilityData(defaultFacilityData);
      }
    }
  }, [locationsTreeArray]);
  const changeMapView = (
    _: React.MouseEvent<HTMLElement, MouseEvent>,
    value: string
  ) => {
    if (value && currentFacilityData?.space_id) {
      setMapViewType(value);
      // localStorage.setItem('map_view_type', value);
    }
  };

  return (
    <>
      <CustomHeader title="Main View">
        {userData.group === "admin" && (
          <FormControl margin="normal" sx={{ width: "240px" }}>
            <Autocomplete
              {...defaultProps}
              disableClearable
              id="demo-simple-select"
              onChange={handleChangeTenant}
              renderTags={() => null}
              value={tenant}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Tenant"
                  className="custom-input"
                />
              )}
            />
          </FormControl>
        )}
      </CustomHeader>
      {(activeStep === 1) && <Box sx={{ width: "100%", mx: "auto", p: 2, pb: 3, minHeight: "100vh" }}>
        <Box
          sx={{
            mb: 2,
            bgcolor: "#fff",
            borderRadius: 2.5,
            boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05) !important",
          }}
        >
          <Box sx={{ display: "flex", gap: 2, flexDirection: { xs: "column", sm: "row" }, justifyContent: "space-between" }}>
            <Box sx={{ flex: 0.4, px: 0, ml: 0, mt: 1 }}>
              <CustomStepper
                activeStep={activeStep}
                handleStepFunction={handleStepFunction}
              />
            </Box>
            <Box sx={{ flex: 0.2, px: 2, py: 1 }}>
              <FormControl fullWidth margin="normal">
                <Autocomplete
                  disableClearable
                  options={locationListOption}
                  onChange={handleChangeFacility}
                  groupBy={(option) =>
                    option.type === "FU"
                      ? "Groups"
                      : option.type === "F"
                        ? "Facilities"
                        : ""
                  }
                  value={selectedFacility}
                  getOptionLabel={(option) => option.name}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} label="Facility/Groups" />
                  )}
                  renderGroup={(params) => (
                    <li key={params.key}>
                      <Box sx={{ color: "#123f93", p: 1 }}>{params.group}</Box>
                      <Box>{params.children}</Box>
                    </li>
                  )}
                />
              </FormControl>
            </Box>
          </Box>

          <Divider />
          {!_.isEmpty(selectedFacility) ? (
            <>
              {/* Autocomplete Section */}


              {/* Facility Details Section */}
              <Box sx={{ borderRadius: "10px!important", boxShadow: "none", px: 2, pt: 2 }}>
                <Box
                  sx={{
                    backgroundColor: "#F6FBFF",
                    px: "20px",
                    py: "2px",
                    borderRadius: "10px",
                    "& .MuiAccordionSummary-expandIconWrapper": { marginLeft: "10px" },
                    "& .MuiAccordionSummary-content": { margin: 0 },
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap="30px"
                    sx={{ width: "100%", justifyContent: "space-between", my: "10px" }}
                  >
                    <Box display="flex" alignItems="center" gap="30px">
                      <Box
                        display="flex"
                        alignItems="center"
                        gap="10px"
                        justifyContent="space-between"
                      >
                        <Box display="flex" alignItems="center" gap="10px">
                          <Box sx={{ lineHeight: 0 }}>
                            {currentFacilityData?.type === "FU" ? (
                              <LabelIcons type={currentFacilityData?.type} />
                            ) : (
                              <img
                                src="/assets/images/FacilityIcon.svg"
                                alt="facility"
                              />
                            )}
                          </Box>
                          <Box>
                            <Link
                              underline="hover"
                              onClick={() =>
                                (facilityDeviceData?.facilityDevicesTotal > 0 && !newDashboardLoader) &&
                                handleGetSummaryData("fcl", currentFacilityData?.key)
                              }
                              sx={{
                                cursor:
                                  facilityDeviceData?.facilityDevicesTotal > 0
                                    ? "pointer"
                                    : "default",
                              }}
                            >
                              <Typography
                                variant="h6"
                                fontWeight={500}
                                fontSize="14px"
                                textTransform="capitalize"
                                color="#32405A"
                              >
                                {selectedFacility.label}
                              </Typography>
                            </Link>
                          </Box>
                        </Box>
                        {facilityDeviceData?.facilityDevicesTotal > 0 && (
                          <Tooltip
                            arrow
                            title={
                              <Box
                                sx={{
                                  borderRadius: 1.5, // Smooth rounded corners
                                  overflow: 'hidden',
                                  minWidth: 180, // Ensures consistent width
                                  boxShadow: 4, // Adds depth for a modern look
                                }}
                              >
                                {/* Header Section (Blue Background) */}
                                <Box sx={{ bgcolor: '#2563EB', px: 2, py: 1.2 }}>
                                  <Typography variant="subtitle2" fontWeight="bold" color="white">
                                    Aggregate Summary
                                  </Typography>
                                </Box>

                                {/* Value Section (White Background) */}
                                <Box sx={{ bgcolor: '#FFFFFF', px: 2, py: 1.2 }}>
                                  <Typography variant="body2" fontWeight="500" color="#000000">
                                    {`Facility : ${selectedFacility.label}`}
                                  </Typography>
                                </Box>
                              </Box>
                            }
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: 'transparent', // Removes default tooltip background
                                  p: 0, // Ensures custom padding is applied
                                  boxShadow: 0, // Prevents double shadows
                                },
                              },
                              arrow: {
                                sx: {
                                  color: '#2563EB', // Arrow color matching the header background
                                },
                              },
                            }}
                          >
                            <Box
                              sx={{ cursor: "pointer" }}
                              onClick={() =>
                                !newDashboardLoader && handleGetSummaryData("fcl", currentFacilityData?.key)
                              }
                            >
                              <CircleSVG
                                getnumber={`${facilityDeviceData?.facilityDevicesTotal}`}
                                bgcolor={
                                  facilityDeviceData?.facilityColorOrder === -Infinity
                                    ? "#FFFFFF"
                                    : colorIndexData[facilityDeviceData?.facilityColorOrder]
                                }
                                fontColor="#000000"
                              />
                            </Box>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>
                    <Box display="flex" gap={1}>
                      {viewType === "map" &&
                        <ToggleButtonGroup
                          color="primary"
                          value={mapViewType}
                          exclusive
                          onChange={changeMapView}
                          sx={{
                            border: "2px solid #1860CC",
                            mt: 1,
                            padding: "0.2rem 0.22rem 0.25rem 0.25rem !important",
                            borderRadius: 5,
                            display: "flex",
                            justifyContent: "space-between",
                            width: '100px',
                            height: "33px",
                            mr: 2
                          }}
                          style={{ height: "2.5em !important" }}
                        >
                          <ToggleButton value={"2D"} sx={{
                            padding: "0px 10px !important",
                            width: "50%",
                            border: '0px',
                            borderRadius: '20px !important',
                            background: (mapViewType === '2D' ? "#123f93 !important" : "transparent"),
                          }}>

                            <Typography sx={{ fontSize: 12, textTransform: 'capitalize', margin: '0px', color: (mapViewType === '2D' ? "#fff" : "#000") }} variant="body1" gutterBottom>
                              2D
                            </Typography>
                          </ToggleButton>
                          <HtmlTooltip
                            title={!currentFacilityData?.space_id ? "3D view is not available." : ""}
                            placement="bottom"
                          >
                            <ToggleButton
                              value={"3D"}
                              sx={{
                                padding: "0px 10px !important",
                                width: "50%",
                                border: '0px',
                                borderRadius: '20px !important',
                                background: (mapViewType === '3D' ? "#123f93 !important" : "transparent"),

                              }}>

                              <Typography sx={{ fontSize: 12, textTransform: 'capitalize', margin: '0px', color: (mapViewType === '3D' ? "#fff" : (!currentFacilityData?.space_id ? '#a4a0a0' : "#000")) }} variant="body1" gutterBottom>
                                3D
                              </Typography>
                            </ToggleButton>
                          </HtmlTooltip>
                        </ToggleButtonGroup>}
                      <HtmlTooltip
                        title={disableMapView ? "Only List View Available" : ""}
                        placement="bottom"
                      >
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <HtmlTooltip
                            title={"List view"}
                            placement="bottom"
                          >
                            <IconButton
                              color="primary"
                              disabled={disableMapView}
                              sx={{
                                backgroundColor: viewType === "list" ? "#123f93" : "#E5F4FF",
                                color: viewType === "list" ? "#fff" : "#123f93",
                                border: "1px solid #123f93",
                                "&:hover": { backgroundColor: "#3C6ED0" },
                              }}
                              onClick={() => { setViewType("list") }}
                            >
                              <FormatListBulletedIcon sx={{ width: 24, height: 24 }} />
                              {/* <img
                          src="/assets/images/Status_list.svg"
                          alt="Facility Icon"
                          style={{ width: 24, height: 24 }}
                        /> */}
                            </IconButton>
                          </HtmlTooltip>
                          <HtmlTooltip
                            title={"Map view "}
                            placement="bottom"
                          >
                            <IconButton
                              disabled={disableMapView || newDashboardLoader}
                              sx={{
                                backgroundColor: viewType === "map" ? "#123f93" : "#E5F4FF",
                                border: "1px solid #123f93",
                                color: viewType === "map" ? "#fff" : "#123f93",
                                // color: "#32405A",
                                "&:hover": { border: "1px solid #123f93" },
                              }}
                              onClick={() => { setViewType("map") }}
                            >
                              {/* <img
                          src="/assets/images/Map_light.svg"
                          alt="Facility Icon"
                          style={{ width: 24, height: 24 }}
                        /> */}
                              <StreetviewIcon sx={{ width: 24, height: 24 }} />
                            </IconButton>
                          </HtmlTooltip>
                        </Box>
                      </HtmlTooltip>
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* Dashboard Section */}
              {viewType === "list" ? (
                newDashboardLoader ? (
                  <DashboardFacilitySkeleton facility={false} />
                ) : (
                  <Box sx={{ mt: 3, px: 2 }}>
                    <DashboardFacility
                      selectedFacility={selectedFacility}
                      floorData={floorData}
                      handleGetSummaryData={handleGetSummaryData}
                    />
                  </Box>
                )
              ) : (
                <MapViewDashboardFacility
                  floorData={floorData}
                  selectedFacility={selectedFacility}
                  currentFacilityData={currentFacilityData}
                  handleGetSummaryData={handleGetSummaryData}
                  locationsList={locationsList}
                  dashboardInterval={null} // Ensure this is intentional
                  floorWithRoomCounts={floorWithRoomCounts}
                  // currentFloor={currentFloor}
                  // setCurrentFloor={setCurrentFloor}
                  sideOverviewData={sideOverviewData}
                  roomDeviceCountData={roomDeviceCountData}
                  floorDeviceCount={floorDeviceCountForAcc}
                  // dashsummeryprops={dashsummeryprops}
                  // currentRoom={currentRoom}
                  mapViewType={mapViewType}
                  variant={variant} // Ensure 'variant' is defined
                  tenantData={tenant} // Ensure 'tenant' is defined
                />
              )}

            </>
          ) : _.isEmpty(selectedFacility) && locationListOption.length === 0 && !locationLoader ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                top: 20,
                py: 4,
                height: "100%", // or a specific height like "200px"
                width: "100%",
              }}
            >
              No facilities found
            </Box>

          ) : (
            <DashboardFacilitySkeleton />
          )}

        </Box>
      </Box>}
      {(activeStep === 2) &&
        <Box sx={{ width: "100%", mx: "auto", p: 2, pb: 3, minHeight: "100vh" }}>
          <Box
            sx={{
              mb: 3,
              pr: 2,
              bgcolor: "#fff",
              borderRadius: 2.5,
              boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05) !important",
            }}
          >
            <Box sx={{ width: "100%", mb: 1 }}>
              <Box sx={{ py: 1.3, display: "flex", alignItems: "center", width: "100%" }}>
                {/* CustomStepper with increased width */}
                <Box sx={{ minWidth: "40%" }}>
                  <CustomStepper activeStep={activeStep} handleStepFunction={handleStepFunction} />
                </Box>

                {/* Right-aligned ToggleButtonGroup */}
                <Box sx={{ ml: "auto" }}>
                  <ToggleButtonGroup
                    value={variant}
                    exclusive
                    onChange={handleToggle}
                    aria-label="text alignment"
                    sx={{
                      borderRadius: 2,
                      overflow: "hidden",
                      border: "1px solid #dcdce1",
                    }}
                  >
                    <ToggleButton
                      value="default"
                      sx={{
                        backgroundColor: variant === "default" ? "#1860CC !important" : "#E5F4FF",
                        color: variant === "default" ? "#fff !important" : "#1860CC",
                        "&:hover": {
                          backgroundColor:
                            variant === "default"
                              ? darken("#1860CC", 0.1)
                              : darken("#E5F4FF", 0.1),
                          color: variant === "default" ? "#fff !important" : "#1860CC",
                        },
                      }}
                    >
                      ug/m3
                    </ToggleButton>
                    <ToggleButton
                      value="count"
                      sx={{
                        backgroundColor: variant === "count" ? "#1860CC !important" : "#E5F4FF",
                        color: variant === "count" ? "#fff !important" : "#1860CC",
                        "&:hover": {
                          backgroundColor:
                            variant === "count"
                              ? darken("#1860CC", 0.1)
                              : darken("#E5F4FF", 0.1),
                          color: variant === "count" ? "#fff !important" : "#1860CC",
                        },
                      }}
                    >
                      Count/m3
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>

              </Box>
            </Box>
          </Box>
          <Box>
            {measurementLoading ? (
              <>
                <LinearProgress color="secondary" />
                <Box sx={{ p: 2, width: "100%", mx: "auto" }}>
                  <DetectionDetailsSkeleton tilesCount={4} />
                  <DetectionDetailsSkeleton tilesCount={5} />
                  <DetectionDetailsSkeleton tilesCount={7} />
                  <DetectionDetailsSkeleton tilesCount={8} />
                </Box>
              </>
            ) : (
              <Box>
                {thirdPartySummary ? (
                  <>
                    <ThirdPartyDeviceMetricCard
                      summaryPage={handleGetThirdPartyDeviceMetrics}
                      metricData={deviceReading}
                    />
                  </>
                ) : (
                  <EnvironmentalMetrics
                    aggMeasureList={aggMeasureListNew}
                    variant={variant}
                    dashboardDetailPage={handleGetDetailMeasurements}
                    categoryList={categoryList}
                  />
                )}
              </Box>
            )}
          </Box>
        </Box>
      }

      {activeStep === 3 && (
        <Box sx={{ width: "100%", mx: "auto", p: 2, pb: 3, minHeight: "100vh" }}>
          <Box
            sx={{
              bgcolor: "#fff",
              borderRadius: 2.5,
              boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.05) !important",

              // ...(isMobile ? { width: "100%", mb: 1 } : { width: "40%", mb: 1 }),
            }}
          >
            <Box sx={{ py: 1.3, display: "flex", alignItems: "center", width: "100%" }}>
              {/* CustomStepper with increased width */}
              <Box sx={{ minWidth: "40%" }}>
                <CustomStepper activeStep={activeStep} handleStepFunction={handleStepFunction} />
              </Box>

            </Box>
            <Divider />
            <Box sx={{ mb: 2, px: 2, py: 1 }}>
              <DetailSummary
                maxWrostData={maxWrostData}
                substance={substance}
                substanceLoc={substanceLoc}
                roomLocationName={roomLocationName}
                handleChangeSubstance={handleChangeSubstance}
                handleChangeLocation={handleChangeLocation}
                substanceDetailLocation={substanceDetailLocation}
                dateRange={dateRange}
                setDateRangeChange={setDateRangeChange}
                setSubstanceChange={setSubstanceChange}
                substanceChange={substanceChange}
                customLoader={customLoader}
                loading={loading}
                relatedSubstanceData={relatedSubstanceData}
                getSummaryData={handleGetDetailMeasurements}
                variant={variant}
                handleExportedReportClick={() => console.log("Report exported")}
                facilityKey={selectedFacility?.key}
                summaryLoader={measurementLoading}
                setCustomLoader={setCustomLoader}
                relatedSubstancesLoader={relatedSubstancesLoader}
                thirdPartySummary={thirdPartySummary}
                deviceReading={deviceReadingMetrics}
                metricsKey={metricsKey}
              />
            </Box>
          </Box>
        </Box >
      )
      }

    </>
  );
}
